import { render, staticRenderFns } from "./ChangePasswordPage.vue?vue&type=template&id=233ce52a&"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports